module.exports = __webpack_public_path__ + "media/images/circles-ec5c59b0.png";